import { readFilters, writeFilters } from '../transactions/filters'

export const TAGS_PATH = '/tags'

/**
 * `/transactions` filtered to one tag, ALL TIME (`month: null`) so the list matches the count beside
 * the link. Built with `writeFilters` so the name is encoded by the one serializer that reads it back.
 */
export function tagTransactionsHref(name: string, today: Date): string {
  const base = readFilters(new URLSearchParams(), today)
  return `/transactions?${writeFilters({ ...base, month: null, tag: name }, today)}`
}
